import { render, staticRenderFns } from "./errors.vue?vue&type=template&id=1e0654c2&scoped=true"
import script from "./errors.vue?vue&type=script&lang=js"
export * from "./errors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0654c2",
  null
  
)

export default component.exports